/**
 * Build-time feature flags. Plain constants — flipped manually here, not via
 * env or runtime config, so the build can statically include or exclude
 * surfaces and SSG output stays consistent.
 */
export const FLAGS = {
  /** Show the "Our Work" / portfolio surfaces (homepage section, /work route,
   *  nav + footer links). Flip to true once real client work / case studies
   *  are ready. While false: PortfolioSection is not rendered on the homepage,
   *  the /work route redirects home, and no link to /work appears anywhere. */
  showWorkSection: false,
};
